<div *ngIf="element.type=='TEXT'" [ngbPopover]="popoverElement" container="body" [popoverTitle]="" triggers="manual"
    #pOver="ngbPopover">

    <app-input-text-laudo [control]="element.control" [required]="element.required"
        [label]="useTemplateLabel ? templateLabel : element.label" [mask]="element.mask" (focusIn)="focusIn(pOver)"
        (focusOut)="focusOut(pOver)"></app-input-text-laudo>

    <ng-template #popoverElement>
        <img *ngIf="preview.type=='MEDIA'" style="width: 250px; height: 250px; object-fit: contain;"
            [src]="preview.control.value" alt="">
        <div *ngIf="preview.type!='MEDIA'">
            {{useTemplateLabel ? templateLabel : element.label}}
        </div>
        <div class="d-flex mt-2">
            <a rel="noopener noreferrer" target="_blank" [href]="preview.control.value" class="btn btn-icon btn-sm btn-primary ml-auto">
                <i class="mdi mdi-open-in-new"></i>
            </a>
        </div>
    </ng-template>

</div>

<app-input-select-laudo *ngIf="element.type=='SELECT'" [control]="element.control" [required]="element.required"
    [label]="useTemplateLabel ? templateLabel : element.label" [options]="element.options">
</app-input-select-laudo>



<div *ngIf="element.type=='MEDIA'" class="d-flex align-items-center justify-content-between">
    <span *ngIf="element.label">{{useTemplateLabel ? templateLabel : element.label}}</span>
    <app-input-img-laudo [url]="element.control.value" (saveEvent)="saveImage(element, $event)"
        (editEvent)="saveImage(element, $event)" (deleteEvent)="saveImage(element, null)" [required]="element.required"
        [loading]="element.loading" [disabled]="element.control.disabled"></app-input-img-laudo>
</div>